import { render, staticRenderFns } from "./account-payments.vue?vue&type=template&id=fa7eb3d2&"
import script from "./account-payments.vue?vue&type=script&lang=js&"
export * from "./account-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports